var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWixLogoSquare = function SvgWixLogoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 5.5,
    stroke: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wixLogoSquare_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7 15.4h-1.623c-.45 0-.872.223-1.125.596L30.781 19.2a.146.146 0 0 1-.242 0l-2.172-3.204a1.358 1.358 0 0 0-1.124-.596h-1.624l3.869 5.707-3.848 5.675h1.624c.45 0 .872-.223 1.125-.596l2.15-3.172a.146.146 0 0 1 .241 0l2.15 3.172c.254.373.675.596 1.126.596h1.623l-3.847-5.675 3.869-5.707ZM22.278 16.564v10.218h.776c.643 0 1.164-.52 1.164-1.164V15.4h-.776c-.643 0-1.164.521-1.164 1.164ZM20.853 15.4h-.69c-.76 0-1.42.526-1.588 1.267l-1.546 6.793-1.352-6.34a2.157 2.157 0 0 0-2.683-1.623c-.784.216-1.365.878-1.534 1.673l-1.339 6.281-1.542-6.783A1.63 1.63 0 0 0 6.99 15.4H6.3l2.589 11.382h.98c.89 0 1.66-.622 1.845-1.493l1.655-7.766a.21.21 0 0 1 .205-.166.21.21 0 0 1 .205.166l1.656 7.767c.186.87.955 1.492 1.845 1.492h.984l2.59-11.382Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wixLogoSquare_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.3 15.4)",
    d: "M0 0h29.4v11.383H0z"
  })))));
};
export default SvgWixLogoSquare;